<script setup lang="ts">
/**
 * CalendlyModal — modal GLOBAL de prise de rendez-vous (monté une fois dans
 * app.vue, piloté par useCalendlyModal). Embed inline officiel Calendly en
 * iframe : aucun script tiers, le visiteur reste sur le site. L'iframe n'est
 * montée qu'à l'ouverture (aucun coût réseau avant). Karim 2026-08-05.
 */
const { isOpen } = useCalendlyModal();
const loaded = ref(false);

watch(isOpen, (open) => {
  if (open) loaded.value = false;
});
</script>

<template>
  <UModal
    v-model:open="isOpen"
    :ui="{
      content: 'sm:max-w-[1000px] w-full sm:rounded-3xl! bg-white! p-0!',
      header: 'hidden!',
      body: 'p-0! sm:p-0!',
    }"
  >
    <template #body>
      <div class="relative h-[80vh] sm:h-[700px]">
        <div
          v-if="!loaded"
          class="absolute inset-0 flex flex-col items-center justify-center gap-3 text-gray-400"
        >
          <UIcon name="i-lucide-loader-2" class="size-8 animate-spin" />
          <p class="text-sm">{{ $t("partage.contact.chargementCalendrier") }}</p>
        </div>
        <iframe
          v-if="isOpen"
          :src="CALENDLY_EMBED_URL"
          :title="$t('partage.contact.planifierAppel')"
          class="w-full h-full border-0 rounded-3xl"
          allow="camera; microphone; fullscreen"
          @load="loaded = true"
        />
        <button
          type="button"
          class="absolute top-3 right-3 size-9 rounded-full bg-white/90 backdrop-blur border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:text-gray-800 hover:bg-white transition-colors"
          :aria-label="$t('association.publicPage.orderErrorBanner.fermer')"
          @click="isOpen = false"
        >
          <UIcon name="i-lucide-x" class="size-4" />
        </button>
      </div>
    </template>
  </UModal>
</template>
